import React, {HTMLAttributes, ReactNode, Ref, UIEventHandler} from "react";
import classNames from "classnames";

import "./ListView.css";

export interface ListViewProps {
    isDragOver?: boolean;
    scrollRootRef?: Ref<HTMLDivElement>;
    contextRootRef?: Ref<HTMLDivElement>;
    onScroll?: UIEventHandler<HTMLDivElement>;
    dragHandlers?: HTMLAttributes<HTMLDivElement>;
    children: ReactNode;
}

export const ListView = ({
    isDragOver = false,
    scrollRootRef,
    contextRootRef,
    onScroll,
    dragHandlers,
    children,
}: ListViewProps) => {
    return (
        <div
            className={classNames({
                "list-view": true,
                "list-view--dragover": isDragOver,
            })}
            ref={scrollRootRef}
            onScroll={onScroll}
            {...dragHandlers}
        >
            {children}
            <div className="list-view_context-root" ref={contextRootRef}/>
        </div>
    );
};
